/**
 * Run `callback` after the next paint when the tab is visible, and after a
 * short timer when it is not.
 *
 * Browsers pause requestAnimationFrame entirely while a tab is hidden. Work
 * that must eventually happen (clearing a loading guard, persisting a load
 * repair) therefore cannot depend on requestAnimationFrame alone: a queued
 * Quote Run is exactly the workload an operator leaves running while they
 * switch to another window, and a guard that never clears wedges the run.
 *
 * In a visible tab the paint callback wins and the timer is a no-op, so the
 * "after React has committed and painted" timing callers rely on is unchanged.
 */
export function afterNextPaintOrTimeout(callback: () => void, fallbackMs = 250): void {
    let settled = false;
    const run = () => {
        if (settled) return;
        settled = true;
        callback();
    };
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(run);
    setTimeout(run, fallbackMs);
}
